<template>
    <my-form 
    class="form-page"
    v-model="form" 
    :readonly="!notMailed"
    table 
    @cancle="cancleHandler" 
    @submit="submitHandler">

        <my-form-item-group title="标段信息">
            <el-form-item 
            class="table-full-row" 
            label="项目"  
            >
                {{form.zbprocode}}
                -
                {{form.zbproname}}
            </el-form-item>

            <el-form-item 
            class="table-full-row" 
            label="标段信息" 
            >
                <my-table :data="form.bdlist">
                    <el-table-column label="标段名称" prop="bdname"></el-table-column>
                    <el-table-column label="标段编码" prop="bdcode"></el-table-column>
                </my-table>
            </el-form-item>
        </my-form-item-group>

        <my-form-item-group title="发票信息">

            <el-form-item 
            class="table-full-row" 
            label="开票金额" 
            >
                {{form.orderssum}} 元
            </el-form-item>

            <el-form-item 
            label="发票类型" 
            prop="fptype" 
            class="table-full-row" 
            :rules="readonly ? [] : newRule('发票类型', 'required')"
            >
                <template 
                v-if="readonly"
                >
                    <my-radio
                        readonly
                        v-model="form.fptype"
                        :data="[{value:'电子增值税普通发票',key:'1'},{value:'纸质增值税专用发票',key:'3'},{value:'增值税专用发票',key:'2'}]"
                    ></my-radio>
                </template>
                <my-radio
                    v-else
                    placeholder="发票类型"
                    v-model="form.fptype"
                    :data="[{value:'电子增值税普通发票',key:'1'},{value:'纸质增值税专用发票',key:'3'},{value:'增值税专用发票',key:'2'}]"
                ></my-radio>
            </el-form-item>

            <el-form-item 
            label="单位全称" 
            prop="kfpdwname" 
            :rules="readonly ? [] : newRule('单位全称', 'required')"
            >
                <template 
                v-if="readonly"
                >
                    {{form.kfpdwname}}
                </template>
                <el-input 
                    v-else
                    v-model="form.kfpdwname"
                ></el-input>
            </el-form-item>

            <el-form-item 
            label="纳税人识别号" 
            prop="by2" 
            :rules="readonly ? [] : newRule('纳税人识别号', 'required')"
            >
                <template 
                v-if="readonly"
                >
                    {{form.by2}}
                </template>
                <el-input 
                    v-else
                    v-model="form.by2"
                ></el-input>
            </el-form-item>

            <el-form-item 
            label="发票地址" 
            prop="kfpdz" 
            :rules="readonly ? [] : newRule('发票地址', 'required')"
            >
                <template 
                v-if="readonly"
                >
                    {{form.kfpdz}}
                </template>
                <el-input 
                    v-else
                    v-model="form.kfpdz"
                ></el-input>
            </el-form-item>

            <el-form-item 
            label="发票电话" 
            prop="kfpdh" 
            :rules="readonly ? [] : newRule('发票电话', 'required')"
            >
                <template 
                v-if="readonly"
                >
                    {{form.kfpdh}}
                </template>
                <el-input 
                    v-else
                    v-model="form.kfpdh"
                ></el-input>
            </el-form-item>

            <el-form-item 
            label="投标人开户行" 
            prop="tbrkhh" 
            :rules="readonly ? [] : newRule('投标人开户行', 'required')"
            >
                <template 
                v-if="readonly"
                >
                    {{form.tbrkhh}}
                </template>
                <el-input 
                    v-else
                    v-model="form.tbrkhh"
                ></el-input>
            </el-form-item>

            <el-form-item 
            label="银行账户" 
            prop="tbryhzh" 
            :rules="readonly ? [] : newRule('银行账户', 'required')"
            >
                <template 
                v-if="readonly"
                >
                    {{form.tbryhzh}}
                </template>
                <el-input 
                    v-else
                    v-model="form.tbryhzh"
                ></el-input>
            </el-form-item>

        </my-form-item-group>

        <my-form-item-group :title="form.fptype === '1' ? '电子发票发送方式' : '邮寄信息'">

            <el-form-item 
            label="投标联系人" 
            prop="tblxr" 
            :rules="readonly ? [] : newRule('投标联系人', 'required')"
            >
                <template 
                v-if="readonly"
                >
                    {{form.tblxr}}
                </template>
                <el-input 
                    v-else
                    v-model="form.tblxr"
                ></el-input>
            </el-form-item>

            <el-form-item 
            label="电话" 
            prop="phone" 
            :rules="readonly ? [] : newRule('电话', 'required')"
            >
                <template 
                v-if="readonly"
                >
                    {{form.phone}}
                </template>
                <el-input 
                    v-else
                    v-model="form.phone"
                ></el-input>
            </el-form-item>

            <template 
            v-if="form.fptype === '1'"
            >
                <el-form-item 
                label="邮箱" 
                prop="email" 
                class="table-full-row" 
                :rules="readonly ? [] : newRule('邮箱', 'required')"
                >
                    <template 
                    v-if="readonly"
                    >
                        {{form.email}}
                    </template>
                    <el-input 
                        v-else
                        v-model="form.email"
                    ></el-input>
                </el-form-item>
            </template>

            <template v-if="form.fptype !== '1'">
                <el-form-item 
                label="发票交付方式" 
                prop="by3" 
                class="table-full-row" 
                :rules="readonly ? [] : newRule('发票交付方式', 'required')"
                >
                    <template 
                    v-if="readonly"
                    >
                        {{form.by3}}
                    </template>
                    <my-select
                        v-else
                        placeholder="发票类型"
                        v-model="form.by3"
                        :data="[{value:'自取',key:'自取'},{value:'邮寄',key:'邮寄'}]"
                    ></my-select>
                </el-form-item>
            </template>
            
            <template
            v-if="form.fptype !== '1' && form.by3==='邮寄'"
            >
                <el-form-item 
                label="邮寄地址" 
                prop="county" 
                :rules="readonly ? [] : newRule('邮寄地址', 'required')"
                >
                    <template 
                    v-if="readonly"
                    >
                        {{address}}
                    </template>

                    <template
                    v-else
                    >
                        <div class="row-3-item">
                            <my-select
                                class="row-items"
                                placeholder="省"
                                v-model="form.province"
                                :url="`${getGetters('mngUrl')}/common/getcitytree.json?tid=0`"
                                :props="{value:'id',label:'text'}"
                            ></my-select>
                            <my-select
                                class="row-items"
                                placeholder="市"
                                v-model="form.city"
                                :url="`${getGetters('mngUrl')}/common/getcitytree.json?tid=${form.province}`"
                                :props="{value:'id',label:'text'}"
                            ></my-select>
                            <my-select
                                class="row-items"
                                placeholder="县"
                                v-model="form.county"
                                :url="`${getGetters('mngUrl')}/common/getcitytree.json?tid=${form.city}`"
                                :props="{value:'id',label:'text'}"
                            ></my-select>
                        </div>
                    </template>
                </el-form-item>

                <el-form-item 
                label="详细地址" 
                prop="address"  
                :rules="readonly ? [] : newRule('详细地址', 'required')"
                >
                    <template 
                    v-if="readonly"
                    >
                        {{form.address}}
                    </template>
                    <el-input 
                        v-else
                        model="form.address"
                    ></el-input>
                </el-form-item>

                <el-form-item 
                label="快递公司" 
                prop="mailgs" 
                class="table-full-row" 
                :rules="readonly ? [] : newRule('快递公司', 'required')"
                >
                    <template v-if="!notMailed">
                        {{form.mailgs}}
                    </template>
                    <template v-else>
                        <el-input v-model="form.mailgs"></el-input>
                    </template>
                </el-form-item>

                <el-form-item 
                label="快递单号" 
                prop="mailno" 
                class="table-full-row" 
                :rules="readonly ? [] : newRule('快递单号', 'required')"
                >
                    <template v-if="!notMailed">
                        {{form.mailno}}
                    </template>
                    <template v-else>
                        <el-input 
                        class="input-short"
                        v-model="form.mailno"
                        ></el-input>
                    </template>

                    <el-button-group>
                        <el-button 
                        v-if="notMailed && !form.mailno"
                        type="success" 
                        @click="getSf"
                        >
                            生成顺丰单号
                        </el-button>

                        <el-button 
                        v-if="form.mailgs === '顺丰速递' && form.mailno"
                        type="warmomg" 
                        @click="doPrint"
                        >
                            打印快递单
                        </el-button>
                    </el-button-group>
                </el-form-item>
            </template>
        </my-form-item-group>

        <el-form-item 
        label="备注" 
        class="table-full-row"
        >
            <el-input 
                v-if="notMailed"
                v-model="form.kfpbz"
            ></el-input>

            <template 
            v-else
            >
                {{form.kfpbz}}
            </template>
        </el-form-item>

        <my-form-item-group 
        v-if="form.fptype === '1' && form.by3 && readonly"
        title="此条数据为执行电子发票前，用户申请的纸质普通发票，以下是用户的发票获取方式：">
            <el-form-item 
            label="发票交付方式" 
            class="table-full-row" 
            >
                {{form.by3}}
            </el-form-item>

            <template v-if="form.by3 === '邮寄'">
                <el-form-item 
                label="邮寄地址" 
                class="table-full-row" 
                >
                    {{address}}
                </el-form-item>

                <el-form-item 
                label="快递公司" 
                prop="mailgs" 
                class="table-full-row" 
                :rules="readonly ? [] : newRule('快递公司', 'required')"
                >
                    <template v-if="!notMailed">
                        {{form.mailgs}}
                    </template>
                    <template v-else>
                        <el-input v-model="form.mailgs"></el-input>
                    </template>
                </el-form-item>

                <el-form-item 
                label="快递单号" 
                prop="mailno" 
                class="table-full-row" 
                :rules="readonly ? [] : newRule('快递单号', 'required')"
                >
                    <template v-if="!notMailed">
                        {{form.mailno}}
                    </template>
                    <template v-else>
                        <el-input 
                        class="input-short"
                        v-model="form.mailno"
                        ></el-input>
                    </template>

                    <el-button-group>
                        <el-button 
                        v-if="notMailed && !form.mailno"
                        type="success" 
                        @click="getSf"
                        >
                            生成顺丰单号
                        </el-button>

                        <el-button 
                        v-if="form.mailgs === '顺丰速递' && form.mailno"
                        type="warmomg" 
                        @click="doPrint"
                        >
                            打印快递单
                        </el-button>
                    </el-button-group>
                </el-form-item>
            </template>
        </my-form-item-group>

        <template slot="btn" slot-scope="scope" class="btn">
            <el-button 
            @click="scope.submitHandler" 
            type="primary" 
            icon="el-icon-circle-check"
            >
                开票
            </el-button>

            <el-button 
            icon="el-icon-circle-close" 
            @click="scope.cancleHandler"
            >
                取消
            </el-button>
            
        </template>
    </my-form>
</template>

<script>
import FORM_PAGE_MIXIN from '@views/mixins/form-page'

export default {
    mixins: [ FORM_PAGE_MIXIN ],
    props: {
        orderscode: {
            type: String,
            default: ''
        }
    },
    data() {
        var that = this;
        return {
            form: {
                
            },

            plist: [],
            clist: [],
            xlist: [],

            detail: '', //1为发票已邮寄
            kj: '',      //1我没申请过

            address: '',
        }
    },
    computed: {
        readonly() {
            return this.kj !== '1';
        },
        notMailed() {
            return this.detail !== '1';
        }
    },
    methods: {
        submitHandler() {
            this.form.shbj = 2;

            this.$post(`${this.getGetters('mngUrl')}/manage/finance/auditorder/kjfp.json`, this.form, (data, res) => {
                ShowMsg('开票成功', 'success');
                this.cancleHandler();
            });
        },

        getSf() {
            this.$post(`${this.getGetters('mngUrl')}/sfbsp/neworder.json`, this.form, data => {
                this.form.mailgs = '顺丰速递';
                this.form.mailno = data.mailno;
            });
        },
        doPrint() {
            var search = toSearch({
                mailno: this.form.mailno,
                orderscode: this.detailExtra.orderid
            });
            
            window.open(`/sfbsp/dzyd.do${search}`);
        }
    },
    created() {
        this.jspInit(`${this.getGetters('mngUrl')}/manage/finance/auditorder/kjfpinit.json`, {
            orderid: this.detailExtra.orderid
        }, data => {
            var form = data.model;

            form.bdlist = data.list;

            // form.fptype = form.fptype || data.fptype;
            // form.by3 = form.by3 || data.by3;
            // form.address = form.address || data.address;

            this.form = form;

            this.jspDataInit(data, ['plist', 'detail', 'kj', 'address']);
        });
    }
}
</script>

<style lang="scss" scoped>
.row-3-item{
    .row-items:first-child /deep/ .el-input__inner{border-radius:4px 0 0 4px;}
    .row-items:last-child /deep/ .el-input__inner{border-radius:0 4px 4px 0;}
    .row-items{float:left; width:33.33%; margin:0;}
}

.input-short{width:199px;}
</style>